export default {
  'onlineStore.store': 'Store',
  'onlineStore.coming_soon': 'Coming Soon',
  'onlineStore.sold_out': 'Sold Out',
  'onlineStore.piece': 'Piece',
  'onlineStore.original_price': 'Original Price',
  'onlineStore.empty': 'No products available at the moment',
  'onlineStore.text.building': 'Content Under Construction',
  'onlineStore.text.more_information':
    "For more information, please visit the brand's official website/social media",
  'onlineStore.category': 'Category',
  'onlineStore.brand': 'Brand',
  'onlineStore.recommend': 'Recommended',
  'onlineStore.package': 'Package',
  'onlineStore.my_product': 'My Product Coupons',
  'onlineStore.12cm.company_name': 'Rui Ding Digital Co., Ltd.',
  'onlineStore.search_placeholder': 'Search product name',
  'onlineStore.search': 'Search',
  'onlineStore.cancel': 'Cancel',
} as Record<string, string>;
